import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'

const TireSize = ({ title, size }) =>
  <Fragment>
    <TireTitle>{ title }</TireTitle>
    <Size>{ size }</Size>
  </Fragment>

TireSize.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string
}

export default TireSize


const TireTitle = styled.div`
  line-height: 17px;
  text-align: left;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(12)}
`

const Size = styled.div`
  line-height: 22px;
  text-transform: uppercase;
  text-align: left;
  color: ${Theme.colors.black};
  ${Mixin.font.GothamBold(18)}
  ${Media.mobile`
    font-size: 14px;
  `}
`

